module.exports = __webpack_public_path__ + "static/media/ZILLASLAB-BOLDITALIC_0.0792d5b2.OTF";